module.exports = __webpack_public_path__ + "static/media/werewolf.fa211e2a.svg";